module.exports = __webpack_public_path__ + "static/media/pasillo_de_luces.526c8766.jpeg";